import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "https://www.alpha-watch-zh.ch";

const setMeta = (selector, attr, value) => {
  let el = document.head.querySelector(selector);
  if (!el) return;
  el.setAttribute(attr, value);
};

export const usePageMeta = (meta) => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!meta) return;
    const url = SITE + pathname;
    document.title = meta.title;
    setMeta('meta[name="description"]', "content", meta.desc);
    setMeta('meta[property="og:title"]', "content", meta.title);
    setMeta('meta[property="og:description"]', "content", meta.desc);
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('link[rel="canonical"]', "href", url);
  }, [meta, pathname]);
};
